module.exports = __webpack_public_path__ + "static/img/carroceria.5acbc76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carroceria.jpg
// module id = f+AQ
// module chunks = 1